import {Text} from '../../../../../../../component/text/text';

import * as styles from './delta-number.scss';

type PropsType = {
    delta: number;
    invertColor: boolean;
};

export function DeltaNumber(props: PropsType): JSX.Element | null {
    const {delta, invertColor} = props;

    if (delta === 0) {
        return null;
    }

    if (delta < 0) {
        return (
            <Text bolder className={!invertColor ? styles.DeltaNumber_negative : styles.DeltaNumber_positive}>
                {delta}
            </Text>
        );
    }

    return (
        <Text
            bolder
            className={!invertColor ? styles.DeltaNumber_positive : styles.DeltaNumber_negative}
        >{`+${delta}`}</Text>
    );
}
